import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {TREND_THEMES} from '../../../constants/trend-themes';
import {FIFA_GROUP_MATCHES} from '../constants/fifa2022/group-matches';
import {HOCKEY_GROUP_MATCHES} from '../constants/hockey-2022/group-matches';
import {MATCHES} from '../constants/matches';
import {Theme} from '../contexts/theme';
import {getMatchDate, isDisplayScore} from '../utils/formatting';
import {fetchData, getCountryIconUrl} from '../utils/helpers';

import Loader from './loader';

import styles from './side-modal.module.css';

const ModalMatchesContent = ({
  id,
  name,
  onTeamClick
}) => {
  const [data, setData] = useState({matches: [], isLoading: true});
  const theme = useContext(Theme);
  const {i18n: {language}} = useTranslation();

  useEffect(async() => {
    if (theme === TREND_THEMES.EURO) {
      return setData({matches: MATCHES[id], isLoading: false});
    }
    if (theme === TREND_THEMES.IHHF) {
      return setData({matches: HOCKEY_GROUP_MATCHES[id], isLoading: false});
    }
    if (theme === TREND_THEMES.FIFA) {
      return setData({matches: FIFA_GROUP_MATCHES[id], isLoading: false});
    }

    try {
      setData({...data, isLoading: true});

      const matches = await fetchData({
        url: `football/worldcup-2022/groups/${id}/matches`
      });

      setData({matches, isLoading: false});
    } catch (e) {
      setData({...data, isLoading: false});
      console.error(`${theme} matches loading error`);
    }
  }, [theme, id]);

  if (data.isLoading) {
    return <Loader color='#fff' />;
  }

  const matchesModalTitle = language === 'www'
    ? `Расписание группы ${name[name.length - 1]}`
    : `${name[0]} тобының кестесі`;

  return (
    <>
      <p className={clsx(styles.title, styles[`title${theme}`])}>
        {matchesModalTitle}
      </p>
      {data.matches.map(({date, localTeam, visitorTeam, id: matchId}) => (
        <div
          key={matchId}
          className={clsx(styles.match, styles[`match${theme}`])}
        >
          <div className={styles.matchWrap}>
            <time
              dateTime={date}
              className={styles.matchDate}
            >
              {getMatchDate(date, language)}
            </time>
            <div className={styles.blockTeams}>
              <p className={clsx(styles.teamName, styles.teamNameLocal)}>
                <span
                  className={styles[`teamName${theme}`]}
                  onClick={() => onTeamClick({
                    id: localTeam.id,
                    countryCode: localTeam.countryCode,
                    teamName: localTeam.name
                  })}
                >
                  {localTeam.name}
                </span>
              </p>
              <div className={styles.scoreWrapper}>
                <img
                  className={styles.teamIcon}
                  src={getCountryIconUrl(localTeam.countryCode)}
                  alt={`Флаг ${localTeam.name}`}
                  width={23}
                  height={16}
                />
                <p className={styles.blockScore}>
                  <span className={styles.blockScoreText}>
                    {isDisplayScore(date, localTeam.score, visitorTeam.score)
                      ? `${localTeam.score} : ${visitorTeam.score}`
                      : '– : –'
                    }
                  </span>
                </p>
                <img
                  className={styles.teamIcon}
                  src={getCountryIconUrl(visitorTeam.countryCode)}
                  alt={`Флаг ${visitorTeam.name}`}
                  width={23}
                  height={16}
                />
              </div>
              <p className={clsx(styles.teamName, styles.teamNameVisitor,)}>
                <span
                  className={styles[`teamName${theme}`]}
                  onClick={() => onTeamClick({
                    id: visitorTeam.id,
                    countryCode: visitorTeam.countryCode,
                    teamName: visitorTeam.name
                  })}
                >
                  {visitorTeam.name}
                </span>
              </p>
            </div>
          </div>
        </div>
      ))}
    </>);
};

export default ModalMatchesContent;
